const DefinitionTypes = {
  NEW: "new",
  EDITED: "edited",
  MD: "md"
} as const;

export default DefinitionTypes;
